'use strict';

var UrdConstants = {
  HEP_TYPE: {
    MARKET: 'UserDefinedReferenceDataMarketProfile',
    FLIGHT: 'UserDefinedReferenceDataFlightProfile'
  },
  ABSOLUTE: 'absolute',
  PERCENTAGE: 'percentage'
};
module.exports = UrdConstants;